module.exports = "./img/8a36f311f42644d60cd7a65e36d176be.png";